module.exports = __webpack_public_path__ + "static/media/design-illustration-2.c25c6b02.svg";